import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import teacherReducer from './slices/teacherSlice';
import settingReducer from './slices/settingSlice';
import authDrawerReducer from "./slices/authDrawerSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    setting: settingReducer,
    authDrawer: authDrawerReducer,
    teacher:teacherReducer
  },
});
